export const getIsColumnHideable = (columnName: string) => {
    const nonHideableColumns = ['contract_name'];
    return !nonHideableColumns.includes(columnName);
};
